"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JWTToken = /** @class */ (function () {
    function JWTToken(token) {
        this.token = token || '';
        this.payLoad = this.decodePayload();
    }
    Object.defineProperty(JWTToken.prototype, "expiration", {
        get: function () {
            return this.payLoad.exp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JWTToken.prototype, "issuedAt", {
        get: function () {
            return this.payLoad.iat;
        },
        enumerable: false,
        configurable: true
    });
    JWTToken.prototype.decodePayload = function () {
        var tokenData = this.token.split('.')[1];
        try {
            return JSON.parse(Buffer.from(tokenData, 'base64').toString('utf8'));
        }
        catch (err) {
            return {
                iat: '',
                exp: 0
            };
        }
    };
    return JWTToken;
}());
exports.default = JWTToken;
//# sourceMappingURL=jwt.token.js.map